module.exports = __webpack_public_path__ + "img/地图D-企鹅归巢.1584c713.png";